/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Coñece xente nova, parola, queda",
      "Número de teléfono incorrecto",
      "Get the app",
      "Continuar con Apple",
      "Continuar con Facebook",
      "Continuar con Google",
      "Entrar",
      "Acceder",
      "Para continuar, por favor, insire os caracteres que ves dentro do recadro.",
      "Continuar",
      "Escribe os caracteres",
      "Control de seguridade",
      "Actualizar",
      "Crea un novo contrasinal que lembres con facilidade:",
      "Gardar",
      "Confirma o contrasinal",
      "O contrasinal debe conter polo menos {{num}} [[characters:num]]",
      "Contrasinal",
      "Crea un novo contrasinal",
      "Badoo - The Blog",
      "Emprego",
      "Parola",
      "Cidades",
      "Xestionar cookies",
      "Copyright © 2006 - presente. Bumble. Tódolos dereitos reservados.",
      "Apple e o logotipo de Apple son marcas comerciais de Apple Inc.{{__EOL__}}Google Play é unha marcar comercial de Google LLC.",
      "Descargar",
      "Facebook",
      "Síguenos",
      "Centro de axuda",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "Resumo",
      "Badoo é parte de Bumble Inc.",
      "Política de privacidade",
      "Safety Centre",
      "Mapa web",
      "Declaración sobre a UK Modern Slavery Act",
      "Condicións de uso",
      "Twitter",
      "Introduce o teu correo ou número de móbil e enviarémosche instrucións para crear un novo contrasinal.",
      "Obter novo contrasinal",
      "Introduce o teu correo ou número de móbil",
      "Contrasinal esquecido",
      "Modelos empregados só como exemplo",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Non tes que agardar a conectar.{{__EOL__}}{{__EOL__}}Podes pasar directamente ao bo, á parte na que tedes conversas máis profundas e vos coñecedes de verdade.",
      "Queres parolar agora?",
      "Ao rexistrarte, acépta-las nosas <a class=\"link\" href=\"{{terms_url}}\">Condicións de uso</a>.<br/>Obtén máis información sobre como usámo-los teus datos na nosa <a class=\"link\" href=\"{{privacy_url}}\">Política de privacidade</a>",
      "Axudándoche a amosarte tal e como es, <br />para ter citas coas que te sintas ben.",
      "Encontros con total confianza.",
      "Ou",
      "Xa tes unha conta?",
      "Rexístrate co teu móbil ou correo",
      "Acada o que queiras do mundo das citas.{{__EOL__}}Así de sinxelo.",
      "Só queres parolar? Está ben.{{__EOL__}}Tes ganas de algo serio? Aledámonos.{{__EOL__}}{{__EOL__}}E se mudas de opinión, non hai problema.",
      "Quero quedar",
      "Procuro unha relación",
      "Quero falar",
      "Coñece xente que queira o mesmo ca ti.",
      "{{name}}, {{age}}",
      "A túa seguridade é a nosa máxima prioridade.",
      "O noso Safety Centre é a nosa zona de información, para atopar todo o apoio que precisas para ter citas seguras.",
      "Visita o noso Safety Centre",
      "A seguridade é o principal,<br/>sempre.",
      "Dende o primeiro momento, pensei que ía funcionar...",
      "Ao principio, non procuraba nada serio...",
      "Un consello para calquera na app de Badoo: amósate tal e como es...",
      "Historias de éxito de Badoo",
      "Ver máis historias de éxito",
      "{{num}}__CUT__Valoración",
      "App Store de Apple",
      "Confía en nós. Conseguimos xuntar a millóns (e millóns e millóns) de persoas dende 2006.",
      "Máis de {{num}} millóns de__CUT__descargas",
      "Máis de {{num}} millóns",
      "Play Store de Google",
      "Sabemos o que facemos.",
      "Inicia sesión co teu correo ou número de móbil",
      "Introduce o teu contrasinal",
      "Esquecíche-lo teu contrasinal?",
      "Acceder",
      "Non tes unha conta?",
      "Usuario",
      "Acceso"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "caracteres"
            ],
            "singular": [
                  "carácter"
            ]
      },
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
